import styled from '@emotion/styled';
import { getConfig } from '@sortlist-frontend/config';
import { Tooltip } from '@sortlist-frontend/design-system/legacy';
import { ImageSourceHelper } from '@sortlist-frontend/media';

import { useSharedComponentsContext } from '../../utils';

const Flag = styled.img`
  height: 1.75rem;
  width: 1.5rem;
`;

type Props = {
  className?: string;
  isPrimary?: boolean;
};

export const ClaimedFlag = ({ className, isPrimary }: Props) => {
  const { t } = useSharedComponentsContext();
  const { publicEnv } = getConfig();

  const flagSrc = isPrimary ? 'claimed-flag-primary' : 'claimed-flag-secondary';

  return (
    <Tooltip placement="bottom" title={t('base:flags.claimedTooltip')}>
      <Flag
        className={className}
        src={ImageSourceHelper.fromUrl(`${publicEnv.s3Bucket}/icons/flags/${flagSrc}.svg`)}
        alt="claimed-flag"
      />
    </Tooltip>
  );
};
